import React from 'react';
import { Box, Flex, Text, Link } from '@chakra-ui/react';
import { TbAlertCircle } from 'react-icons/tb';
import theme from 'ui/theme/theme';

function InactiveBanner() {
  return (
    <Box
      border="1px solid"
      // color={theme.colors.semantics['warning-light']}
      borderColor={theme.colors.semantics.warning}
      p={2}
      bg={theme.colors.semantics['warning-light']}
      borderRadius={6}
      wordBreak="break-all"
      mt={2}
      mb={2}
    >
      <Flex>
        <TbAlertCircle color={theme.colors.semantics.warning} />
        <Flex ml="12px">
          <Text fontSize="md" color="gray.600">
            Your free trial or subscription has expired.{' '}
            <Link color="blue.500" cursor="pointer" href="/pricing">
              Renew
            </Link>{' '}
            now to continue enjoying full access to all features.
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
}

export default InactiveBanner;
